import { Languagei18n } from '../enums/languages';

const LANGUAGES = [
  { value: Languagei18n.PORTUGUESE, label: 'Português' },
  { value: Languagei18n.ENGLISH, label: 'English' },
  { value: Languagei18n.SPANISH, label: 'Español' },
];

const SUPPORTED_LANGUAGES = [
  Languagei18n.PORTUGUESE,
  Languagei18n.ENGLISH,
  Languagei18n.SPANISH,
];

export { LANGUAGES, SUPPORTED_LANGUAGES };
